import { render, staticRenderFns } from "./ElementsSideMenu.vue?vue&type=template&id=ed817414&scoped=true&"
import script from "./ElementsSideMenu.vue?vue&type=script&lang=js&"
export * from "./ElementsSideMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed817414",
  null
  
)

export default component.exports